import { TRIX as defaultOptions } from "./defaultOptionsForComputation";
import ema from "./ema";
import { isFiniteNumber } from "../utils";

export default function () {
  let options = defaultOptions;

  function calculator(data = []) {
    if (!Array.isArray(data) || data.length === 0) {
      return [];
    }

    const period = Math.max(
      1,
      Math.floor(options?.period ?? defaultOptions.period ?? 1),
    );
    const sourcePath =
      options?.sourcePath ?? defaultOptions.sourcePath ?? "close";
    const ema1Calculator = ema().options({ windowSize: period, sourcePath });
    const ema1Values = ema1Calculator(data);

    const ema1Series = ema1Values.map((value) => ({ value }));
    const ema2Calculator = ema().options({
      windowSize: period,
      sourcePath: "value",
    });
    const ema2Values = ema2Calculator(ema1Series);

    const ema2Series = ema2Values.map((value) => ({ value }));
    const ema3Calculator = ema().options({
      windowSize: period,
      sourcePath: "value",
    });
    const ema3Values = ema3Calculator(ema2Series);

    const trixValues = new Array(data.length).fill(undefined);

    for (let i = 1; i < ema3Values.length; i += 1) {
      const current = ema3Values[i];
      const previous = ema3Values[i - 1];

      if (
        isFiniteNumber(current) &&
        isFiniteNumber(previous) &&
        previous !== 0
      ) {
        trixValues[i] = (current / previous - 1) * 100;
      }
    }

    return trixValues;
  }

  calculator.undefinedLength = function () {
    const period = Math.max(
      1,
      Math.floor(options?.period ?? defaultOptions.period ?? 1),
    );
    return period * 3;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
